import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import { createShowVoucherExtraBanner } from '@/app/components/search/components/Banners/VoucherExtraBanner/createShowVoucherExtraBanner.ts';
import { getCheckVoucherExtraValues } from '@/app/components/search/utils/voucherExtra.ts';
import { getSearchParam } from '@/app/common/urlParametersUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { StarTrack } from '../../startrack.ts';
import { createSearchServedPayload } from '../searchServed.ts';

type SearchServedProps = {
  searchId: string;
  searchParams: SearchParams;
  productsData: ProductsData;
  localization: Localization;
  searchInfoData: SearchInfoData;
  starTrack: StarTrack;
};

export const searchServedEvents = ({
  searchId,
  searchParams,
  productsData,
  localization,
  searchInfoData,
  starTrack,
}: SearchServedProps) => {
  const sort = getSearchParam(searchParams, URLParameters.SORT);
  const { brand, country, currency } = localization;
  const { productCounters, message, apiStatus, dealCards, transport, vcSearchId, instantSearch, apexAvailabilityFlag } =
    productsData;

  let voucherCode = '';
  const showVoucherExtraBanner = createShowVoucherExtraBanner({ searchInfoData, productsData, localization });
  if (showVoucherExtraBanner) {
    const voucherExtraValues = getCheckVoucherExtraValues(searchParams, brand, country, currency);
    voucherCode = voucherExtraValues?.voucherCode || '';
  }

  starTrack.searchServed(
    createSearchServedPayload({
      searchId,
      responseDetail: message || apiStatus,
      productCounters,
      numberOfDealCards: dealCards?.length || 0,
      defaultSortOrder: sort,
      vcSearchId,
      transport,
      voucherCode,
      instantSearch,
      apexAvailabilityFlag,
    })
  );
};
